export type WishlistFilters = {
  customerQ?: string;
  productQ?: string;
  customerId?: string;
  productId?: string;
  availability?: string;
  page?: number;
  pageSize?: number;
};

export type WishlistPage<T> = {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
};
export type WishlistSummary = {
  customerId: string;
  customer: string;
  email: string;
  totalItemCount: number;
  matchingItemCount: number;
  lastAddedAt: string;
};
export type WishlistAdminItem = {
  id: string;
  productId: string;
  variantId: string | null;
  title: string;
  sku: string | null;
  addedAt: string;
  availability:
    | "available"
    | "productDeleted"
    | "productInactive"
    | "variantUnavailable";
};

export function wishlistQuery(filters: WishlistFilters = {}): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") query.set(key, String(value));
  }
  return query.toString();
}
